import { render, staticRenderFns } from "./PayFastForm.vue?vue&type=template&id=7ff976e0&"
import script from "./PayFastForm.vue?vue&type=script&lang=js&"
export * from "./PayFastForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports